import { CardBody, HoverPreviewImage, Metric, Metrics } from "common/hovercards/CardBody";
import { MountOnHoverCard } from "common/hovercards/MountOnHoverCard";
import { Distance, Duration, Elevation } from "common/units";
import { commonMetrics, Msg } from "lib/localization";
import PropTypes from "prop-types";
import React from "react";

export class TRouteCard extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    distance: PropTypes.number.isRequired,
    elevationLoss: PropTypes.number,
    movingTime: PropTypes.number,
    elevationGain: PropTypes.number.isRequired,
  };

  render() {
    const { children, ...props } = this.props;

    return (
      <MountOnHoverCard wrappedChildren={children}>
        <TRouteBody {...props} />
      </MountOnHoverCard>
    );
  }
}

export const TRouteBody = ({ id, type, distance, elevationGain, elevationLoss, movingTime, name }) => {
  const image = <HoverPreviewImage type={type} id={id} />;
  const content = (
    <Metrics>
      <Metric label={<Msg m={commonMetrics.distance} />} value={<Distance short value={distance} />} />
      <Metric label={<Msg m={commonMetrics.elevationGain} />} value={<Elevation short value={elevationGain} />} />
      {type === "trip" ? (
        <Metric label={<Msg m={commonMetrics.movingTime} />} value={<Duration short valueOnly value={movingTime} />} />
      ) : (
        <Metric label={<Msg m={commonMetrics.elevationLoss} />} value={<Elevation short value={elevationLoss} />} />
      )}
    </Metrics>
  );

  return <CardBody header={name} image={image} content={content} />;
};
